import React, {useState} from "react";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import CreateReserveAccountModal from "./modal/CreateReserveAccountModal";
import UpdateReserveAccountInstantModal from "./modal/UpdateReserveAccountInstantModal";
import { permissionCssClass } from "../../../../../../../../../util/Helpers";
import { Permissions, PermissionType } from "../../../../../../../../../util/Permissions";

const ReservedAccount = (props) => {

    const adminUser = useSelector(state => state.auth.user);
    /* Reserve Account Modal State Management */
    const [showCreateReserveAccountModal, setShowCreateReserveAccountModal] = useState(false);
    const [updateReserveAccountInstantModal, setUpdateReserveAccountInstantModal] = useState(null);

    const ReservedAccountList = _ => {

        if (props.nubans.length === 0){
            return <div >
                        <p className="text-muted">
                            No Reserved Account found
                        </p>
                    </div>
        }
    
        return props.nubans.map((nuban, i) => <div key={`nuban-${i}`}>
                {/* <!--begin::Item--> */}
                <div className="row">
                    {/* <!--begin::Field--> */}
                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Reference</span>
                        <span className="text-muted font-weight-bold font-size-sm my-1">{nuban.ref}</span>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Account Number</span>
                        <span className="text-muted font-weight-bold font-size-sm my-1">{nuban.accountNumber}</span>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Account Name</span>
                        <span className="text-muted font-weight-bold font-size-sm my-1">{nuban.accountName}</span>
                    </div>
                    {/* <!--end::Field--> */}
                </div>
                <div className="row">
                    {/* <!--begin::Field--> */}
                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Instant Deposit</span>
                        <span className="text-muted font-weight-bold font-size-sm my-1">
                            {nuban.instantDeposit ? "Enabled" : "Disabled"} 
                            <button 
                                title="Change Status"
                                className={`btn btn-icon btn-sm ml-1 pb-1 ${permissionCssClass(adminUser, Permissions.NUBANS, PermissionType.UPDATE)}`}
                                onClick={_ => setUpdateReserveAccountInstantModal(nuban)}
                            >
                                <span className="svg-icon svg-icon-sm svg-icon-primary">
                                    <SVG
                                    title="Change Status"
                                    src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                    />
                                </span>
                            </button>
                        </span>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Gateway</span>
                        <span className="text-muted font-weight-bold font-size-sm my-1">{nuban.gateway.toUpperCase()}</span>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Bank Name</span>
                        <span className="text-muted font-weight-bold font-size-sm my-1">{nuban.bankName}</span>
                    </div>
                    {/* <!--end::Field--> */}
                    
                </div>
                {/* <!--end::Item--> */}
            </div>
        )
    }

    return <div className="row">
                <div className="col-12">
                    {/* <!--begin::List Widget 14--> */}
                    <div className="card card-custom gutter-b">
                        {/* <!--begin::Header--> */}
                        <div className="card-header border-0">
                            <h3 className="card-title font-weight-bolder text-dark">Reserved Account</h3>

                            <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.NUBANS, PermissionType.CREATE)}`}>
                                <button  
                                    className="btn btn-primary font-weight-bolder font-size-sm"
                                    onClick={_ => setShowCreateReserveAccountModal(true)}
                                >
                                    <span className="svg-icon svg-icon-md svg-icon-white">
                                        <SVG
                                            title="Transactions"
                                            src={toAbsoluteUrl("/media/svg/icons/Code/Plus.svg")}
                                        />
                                    </span>
                                    Reserve Account
                                </button>
                            </div>
                        </div>
                        {/* <!--end::Header--> */}
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-2">
                            <ReservedAccountList />
                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::List Widget 14--> */}
                <CreateReserveAccountModal  {...{...props, showCreateReserveAccountModal, setShowCreateReserveAccountModal}} />
                { updateReserveAccountInstantModal && <UpdateReserveAccountInstantModal {...{...props, updateReserveAccountInstantModal, setUpdateReserveAccountInstantModal}} /> }
                </div>
                
            </div>


}

export default ReservedAccount;